//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var loadableKeys = ['searchTerm', 'perPage', 'sortColumn', 'sortDirection'];

export default {
    props: ['columns', 'url', 'extrasColumnName', 'requestData', 'storageKey'],
    data: function data() {
        var columnIndexMap = new Map();

        for (var i = 0; i < this.columns.length; ++i) {
            columnIndexMap.set(this.columns.name, i);
        }

        return {
            error: false,
            columnIndexMap: columnIndexMap,
            rows: [],
            searchTerm: null,
            perPage: 50,
            sortColumn: null,
            sortDirection: 'asc',
            pagination: {
                current_page: 1,
                from: 1,
                to: 1,
                last_page: 1,
                total: 1
            }
        };
    },
    created: function created() {
        if (this.storageKey != null) {
            var json = JSON.parse(sessionStorage.getItem(this.storageKey));
            if (json instanceof Object) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = loadableKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;

                        this[key] = json[key];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }

        this.reloadRows();
    },

    methods: {
        reloadRows: function reloadRows() {
            var _this = this;

            $.ajax(this.url, {
                dataType: 'json',
                data: Object.assign({
                    q: this.searchTerm,
                    order: {
                        column: this.sortColumn,
                        dir: this.sortDirection
                    },
                    per_page: this.perPage,
                    page: this.pagination.current_page
                }, this.requestData || {})
            }).then(function (response) {
                var data = Array.from(response.data || response);
                var newRows = [];

                if (data != null) {
                    data.forEach(function (item) {
                        var rowCells = [];
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = _this.columns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var column = _step2.value;

                                var content = column.data instanceof Function ? column.data.call(column, item, column) : item[column.name];

                                rowCells.push(column.html ? { html: content } : { text: content });
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        newRows.push({
                            data: item,
                            cells: rowCells
                        });
                    });
                }

                if (response.meta != null) {
                    _this.pagination.current_page = response.meta.current_page;
                    _this.pagination.from = response.meta.from;
                    _this.pagination.to = response.meta.to;
                    _this.pagination.last_page = response.meta.last_page;
                    _this.pagination.total = response.meta.total;
                }

                _this.rows = newRows;
                _this.error = false;
            }).catch(function (xhr) {
                _this.rows = [];
                _this.error = xhr.responseJSON.message || 'Unknown error';
            });
        },
        nextPage: function nextPage() {
            if (this.pagination.current_page + 1 <= this.pagination.last_page) {
                ++this.pagination.current_page;
                this.update();
            }
        },
        prevPage: function prevPage() {
            if (this.pagination.current_page - 1 >= 1) {
                --this.pagination.current_page;
                this.update();
            }
        },
        sort: function sort(column) {
            var columnSortColumn = column.sortColumn || column.name;
            if (this.sortColumn === columnSortColumn) {
                this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
            } else {
                this.sortDirection = 'asc';
                this.sortColumn = columnSortColumn;
            }
            this.update();
        },
        update: function update() {
            this.save();
            this.reloadRows();
        },
        updateResettingPage: function updateResettingPage() {
            this.pagination.current_page = 1;
            this.update();
        },
        save: function save() {
            if (this.storageKey == null) {
                return;
            }

            var storageData = {};
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = loadableKeys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var key = _step3.value;

                    storageData[key] = this[key];
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            sessionStorage.setItem(this.storageKey, JSON.stringify(storageData));
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/ServerSideDataTable.vue
// module id = 48
// module chunks = 0